import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

/**
 * Preset Aura personalitzat per alinear colors i radius amb gestio-velneo / tokens CRM.
 */
export const CrmAuraPreset = definePreset(Aura, {
  primitive: {
    borderRadius: {
      md: '12px',
      lg: '12px',
      xl: '16px',
    },
  },
  semantic: {
    primary: {
      50: '#eff6ff',
      100: '#dbeafe',
      200: '#bfdbfe',
      300: '#93c5fd',
      400: '#60a5fa',
      500: '#2563eb',
      600: '#1d4ed8',
      700: '#1e40af',
      800: '#1e3a8a',
      900: '#172554',
      950: '#172554',
    },
    formField: {
      paddingX: '0.9rem',
      paddingY: '0.75rem',
      borderRadius: '{border.radius.md}',
    },
    focusRing: {
      width: '0',
      style: 'none',
      color: 'transparent',
      offset: '0',
      shadow: 'none',
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
        formField: {
          borderColor: '#e2e8f0',
          hoverBorderColor: '#cbd5e1',
          focusBorderColor: '{primary.500}',
        },
        content: {
          borderColor: '#e2e8f0',
        },
      },
    },
  },
  components: {
    button: {
      root: {
        borderRadius: '{border.radius.md}',
        label: {
          fontWeight: '600',
        },
      },
      colorScheme: {
        light: {
          root: {
            secondary: {
              background: '#ffffff',
              hoverBackground: '#f8fafc',
              activeBackground: '#f1f5f9',
              borderColor: '#e2e8f0',
              hoverBorderColor: '#cbd5e1',
              activeBorderColor: '#cbd5e1',
              color: '#0f172a',
              hoverColor: '#0f172a',
              activeColor: '#0f172a',
            },
          },
          outlined: {
            secondary: {
              hoverBackground: '#f8fafc',
              activeBackground: '#f1f5f9',
              borderColor: '#e2e8f0',
              color: '#0f172a',
            },
          },
        },
      },
    },
    inputtext: {
      root: {
        borderRadius: '{border.radius.md}',
      },
    },
    select: {
      root: {
        borderRadius: '{border.radius.md}',
      },
    },
    card: {
      root: {
        borderRadius: '{border.radius.xl}',
        shadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
      },
      body: {
        padding: '1.25rem',
      },
    },
    panel: {
      root: {
        borderRadius: '{border.radius.xl}',
        borderColor: '#e2e8f0',
      },
      header: {
        borderColor: '#e2e8f0',
      },
    },
    dialog: {
      root: {
        borderRadius: '{border.radius.xl}',
        shadow: '0 24px 72px rgba(15, 23, 42, 0.28)',
      },
    },
    datatable: {
      headerCell: {
        background: '#f8fafc',
        color: '#64748b',
      },
      bodyCell: {
        padding: '0.95rem 1rem',
      },
    },
    tag: {
      root: {
        borderRadius: '999px',
        fontWeight: '600',
      },
    },
    message: {
      root: {
        borderRadius: '{border.radius.md}',
      },
    },
  },
});
